import React, { PureComponent } from 'react';
import { Link, Redirect } from 'react-router-dom';
import AgeExit from 'modules/signup/AgeExit';
import SignupCountry from 'modules/signup/components/SignupCountry';
import SignupDetails from 'modules/signup/components/SignupDetails';
import SignupPassword from 'modules/signup/components/SignupPassword';
import SignupPrivacy from 'modules/signup/components/SignupPrivacy';
import SignupResearch from 'modules/signup/components/SignupResearch';
import SignupCompletion from 'modules/signup/components/SignupCompletion';
import SignupType from 'modules/signup/components/SignupType';
import SignupYearOfBirth from 'modules/signup/components/SignupYearOfBirth';
import strings from 'helper/localization/localization';

export default class Signup extends PureComponent {
  constructor(props) {
    super(props);

    // State
    this.state = {
      signupStep: 0,
      tooYoungCancel: false,
      signupCompleted: false,
      verificationToken: null,
    };

    // Properties
    this.api = this.props.api;
    this.updateUser = this.props.updateUser;
    this.user = this.props.user;
    this.newUserDetails = {
      yearOfBirth: this.user.yearOfBirth || null,
    };
    this.signupSteps = [
      SignupType,
      SignupDetails,
      SignupPassword,
      SignupCountry,
      SignupYearOfBirth,
      SignupPrivacy,
      SignupResearch,
      SignupCompletion
    ];

    // Bindings
    this.updateUserDetails = this.updateUserDetails.bind(this);
    this.signUp = this.signUp.bind(this);
    this.tooYoung = this.tooYoung.bind(this);
  }

  exitSdk = () => {
    this.props.sdk.exit();
  }

  signUp() {
    this.api.signUp({
      anonymous: false,
      ...this.newUserDetails
    }, (api) => {
      this.setState({ verificationToken: api.res.body.token });
    });
  }

  updateUserDetails(key, value) {
    if (key !== null) {
      this.newUserDetails[key] = value;
    }

    if (this.state.signupStep === (this.signupSteps.length - 1)) {
      this.updateUser(this.newUserDetails);
      this.setState({ signupCompleted: true });
    } else {
      // Increment the signupStep index
      this.setState({
        signupStep: this.state.signupStep + 1,
      });
    }
  }

  tooYoung() {
    this.setState({ tooYoungCancel: true });
  }

  render() {
    if (this.state.signupCompleted) {
      return this.props.exitSdkAfterSignup ?
        <Redirect to="/sdk-exit" /> :
        <Redirect to="/details" />;
    }

    if (this.state.tooYoungCancel) {
      return <AgeExit />;
    }
    const CurrentComponent = this.signupSteps[this.state.signupStep];

    let cancelLink = null;
    let cancelLinkLabel = (CurrentComponent === SignupCompletion) ? strings.back : strings.cancel;
    if (this.props.exitSdkAfterSignup) {
      cancelLink = (
        <button className="btn btn-link btn-lg mt-3" onClick={this.exitSdk}>
          {cancelLinkLabel}
        </button>
      );
    } else if (this.props.backToProfileLink) {
      cancelLink = (
        <a href={this.props.backToProfileLink} className="btn btn-link btn-lg mt-3">
          {cancelLinkLabel}
        </a>
      );
    } else {
      cancelLink = (
        <Link to="/login" className="btn btn-link btn-lg mt-3">
          {cancelLinkLabel}
        </Link>
      );
    }
    const signupComponent =
      (<CurrentComponent
        api={this.api}
        user={this.user}
        updateDetails={this.updateUserDetails}
        signUp={this.signUp}
        email={this.newUserDetails.email}
        tooYoung={this.tooYoung}
        verificationToken={this.state.verificationToken}
        enteredFromWHT={this.props.enteredFromWHT}
        backToProfileLink={this.props.backToProfileLink}
      />);

    let headline;
    switch (CurrentComponent) {
      case SignupPrivacy:
        headline = strings.pleaseReadPrivacyPolicy;
        break;
      case SignupResearch:
        headline = strings.helpUsImprove;
        break;
      case SignupCompletion:
        headline = strings.checkConfirmationEmail;
        break;
      default:
        headline = strings.createAnAccount;
    }

    return (
      <div className="container">
        <div className="row mb-3">
          <div className="col">
            <h6>{strings.signUpWithMimi}</h6>
            <h2>{headline}</h2>
          </div>
        </div>
        { signupComponent }
        <div className="cancel-link">
          {cancelLink}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/signup/Signup.jsx